import { useState } from "react";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { ScrollProps } from "../../components/AdvancedSearch";
import { Container, Content, Hero, PolicyCard } from "./styles";

export default function PrivacyPolicy() {
  const [scrollTop, setScrollTop] = useState<ScrollProps>({
    y: 0,
    lastY: 0,
  } as ScrollProps);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const currentScrollTop = event.currentTarget.scrollTop;
    setScrollTop((prevState) => ({ y: currentScrollTop, lastY: prevState.y }));
  };

  return (
    <Container onScroll={handleScroll}>
      <Header
        show={show}
        setShow={setShow}
        scroll={scrollTop}
        search={search}
        setSearch={setSearch}
      />
      <Content>
        <Hero>
          <h1>Política de Privacidade - Nogueira Corretores</h1>
        </Hero>

        <PolicyCard>
          <p>
            A presente Política de Privacidade tem por finalidade estabelecer as
            regras sobre obtenção, uso e armazenamento dos dados e informações
            coletadas dos visitantes e usuários, além do registro de suas
            atividades.
          </p>
          <p>
            A sua privacidade é de extrema relevância para nós. A política da
            NOGUEIRA CORRETORES visa respeitar a sua privacidade em relação a
            qualquer informação sua que possamos coletar no site da NOGUEIRA
            CORRETORES, e quaisquer outros sites que possuímos e operamos.
          </p>
          <p>
            Recebemos informações pessoais apenas quando você nos deseja
            fornecê-las. Naturalmente, são informações que precisamos para lhe
            prestar algum tipo de serviço relativo à intermediação de compra e
            venda de imóveis. O fazemos por meios justos e legais, com o seu
            conhecimento e consentimento. Também informamos quais dados estamos
            coletando, por que estamos coletando e como serão usados.
          </p>
          <p>
            Apenas retemos as informações coletadas pelo tempo necessário para
            fornecer o serviço solicitado. Quando armazenamos dados, os
            protegemos através de meios comercialmente aceitáveis para evitar
            perdas e roubos, bem como acesso, divulgação, cópia, uso ou
            modificação não autorizados.
          </p>
          <p>
            Não compartilhamos informações de identificação pessoal publicamente
            ou com terceiros, exceto quando autorizado pelo usuário ou exigido
            por lei.
          </p>
          <p className="strong">
            O nosso site pode ter links para sites externos que não são operados
            por nós. Esteja ciente de que não temos controle sobre o conteúdo e
            práticas desses sites e não podemos aceitar responsabilidade por
            suas respectivas políticas de privacidade.
          </p>
          <p>
            Você é livre para recusar a nossa solicitação de informações
            pessoais, entendendo que talvez não possamos fornecer alguns dos
            serviços desejados. O uso continuado de nosso site será considerado
            como aceitação de nossas práticas em torno de privacidade e
            informações pessoais.
          </p>

          <h3>Quais dados coletamos?</h3>
          <p>
            Nossa empresa pode coletar os seguintes dados:{" "}
            <strong>
              Nome completo, E-mail, Telefone, CPF, RG, Data de Nascimento e
              Endereço
            </strong>
            , todos inseridos pelo CLIENTE/Usuário sob expresso consentimento e
            utilizados para fins de execução do contrato.
          </p>
          <p>
            Também coletamos, caso necessário, algumas informações técnicas do
            seu dispositivo, tais como endereço IP e Porta Lógica de Origem,
            registros de data e horário de cada ação que você realizar em nosso
            website, telas acessadas e ID da sessão.
          </p>

          <h3>Como coletamos seus dados?</h3>
          <p>
            A maioria dos dados que coletamos é diretamente provida por você,
            usuário.
          </p>
          <ul>
            <li>
              Quando você se registra on-line, preenche formulário de contato ou
              formulário de imóvel e/ou realiza uma solicitação de informações
              através do nosso website.
            </li>
            <li>
              Quando você fornece voluntariamente algum retorno (feedback) em
              quaisquer de nossos meios de comunicação, como e-mail.
            </li>
          </ul>

          <h3>Como utilizaremos seus dados?</h3>
          <p>
            Nossa empresa coleta seus dados somente para fins de contato,
            podendo utilizá-los para processar os seus pedidos, gerenciar suas
            solicitações e, quando autorizada, enviar e-mails sobre ofertas
            especiais em outros produtos ou serviços que achamos que você possa
            gostar.
          </p>

          <h3>Como armazenamos seus dados?</h3>
          <p>
            Nossa empresa armazena seus dados de maneira segura nos{" "}
            <strong>servidores dedicados da AWS (Amazon Web Services)</strong>,
            adotando as medidas de cibersegurança necessárias para manutenção de
            um ambiente virtual íntegro e condizente com as práticas
            mercadológicas de compliance e segurança virtual.
          </p>
          <p>
            A empresa manterá seus dados pessoais em nosso cadastro pelo tempo
            necessário para atendimento das finalidades apresentadas nesta
            Política de Privacidade, respeitando o período de retenção de dados
            determinado pela legislação aplicável.
          </p>
          <p>
            Caso o usuário solicite a exclusão de sua conta/de seus dados, as
            suas informações pessoais fornecidas durante a utilização dos
            serviços da NOGUEIRA CORRETORES serão excluídas definitivamente
            sempre que a legislação assim o exigir.
          </p>
          <p>
            Em alguns casos, a NOGUEIRA CORRETORES poderá reter informações dos
            usuários/visitantes mesmo que este exclua seus dados, tais como nas
            hipóteses de guarda obrigatória de registros previstas na lei
            aplicável, se houver uma questão não resolvida relacionada ao seu
            acesso ou caso seja necessário para interesses comerciais legítimos.
          </p>

          <h3>Quais são os seus direitos de proteção de dados pessoais?</h3>
          <p>
            Nossa empresa gostaria de lhe deixar plenamente ciente de seus
            direitos:
          </p>
          <ul>
            <li>
              Direito ao acesso: você tem o direito de solicitar à empresa
              cópias de seus dados pessoais, através do e-mail:{" "}
              <a href="mailto:william@hubnogueira.com.br">
                william@hubnogueira.com.br
              </a>
              .
            </li>
            <li>
              Direito à retificação: você tem o direito de pedir à empresa a
              correção de informações pessoais imprecisas e a complementação de
              informações incompletas.
            </li>
            <li>
              Direito à exclusão: você tem o direito de solicitar à empresa a
              exclusão de seus dados pessoais, observadas as condições legais
              aplicáveis.
            </li>
            <li>
              Direito à revogação de consentimento: você pode revogar o
              consentimento relativo aos dados pessoais fornecidos.
            </li>
            <li>
              Direito de oposição ao processamento dos dados: você tem o direito
              de se opor ao processamento de seus dados pessoais.
            </li>
            <li>
              Direito à informação sobre possíveis compartilhamentos: você tem o
              direito de ser informado sobre o compartilhamento de seus dados
              com terceiros.
            </li>
            <li>
              Direito à portabilidade: você tem o direito de requerer a
              transferência dos dados coletados para outra organização ou
              diretamente ao titular.
            </li>
          </ul>

          <p>
            Se você submeter um desses pedidos, temos até um mês para responder.
            Para exercer qualquer um desses direitos, entre em contato por
            e-mail:{" "}
            <a href="mailto:william@hubnogueira.com.br">
              william@hubnogueira.com.br
            </a>
            .
          </p>
          <p>
            Destaque-se que a NOGUEIRA CORRETORES não retém dados obtidos sem o
            consentimento do usuário, respeitando sempre a integralidade do
            disposto na presente política de privacidade.
          </p>
          <span>
            <p>Esta política é efetiva a partir de setembro/2024.</p>
            <p style={{ marginTop: "1rem", fontWeight: 600, color: "#0E2244" }}>
              NOGUEIRA CORRETORES
            </p>
          </span>
        </PolicyCard>
      </Content>
      <Footer />
    </Container>
  );
}
